export default __webpack_public_path__ + "static/media/ReportDarkActive.459b8829.svg";